import React from 'react';
import { Link } from 'react-router-dom';
import { ClockIcon } from '@heroicons/react/24/outline';
import Footer from '../../components/Layout/Footer';

const PendingApproval = () => {
    return (
        <div className="min-h-screen flex flex-col bg-gray-50">
            <div className="flex-1 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-md w-full space-y-8">
                <div>
                    <div className="mx-auto h-12 w-12 bg-yellow-500 rounded-lg flex items-center justify-center">
                        <ClockIcon className="h-6 w-6 text-white" />
                    </div>
                    <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
                        Account Pending Approval
                    </h2>
                    <p className="mt-2 text-center text-sm text-gray-600">
                        Your registration is pending Super Admin approval
                    </p>
                </div>

                <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6">
                    <div className="flex">
                        <div className="flex-shrink-0">
                            <ClockIcon className="h-5 w-5 text-yellow-400" />
                        </div>
                        <div className="ml-3">
                            <h3 className="text-sm font-medium text-yellow-800">
                                Waiting for Approval
                            </h3>
                            <div className="mt-2 text-sm text-yellow-700">
                                <p>
                                    Your account registration has been submitted and is currently pending approval from the Super Admin.
                                </p>
                                <p className="mt-2">
                                    You will be able to login once your account has been approved. You will receive a notification once the approval is complete.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="text-center">
                    <Link
                        to="/login"
                        className="font-medium text-blue-600 hover:text-blue-500"
                    >
                        Back to Login
                    </Link>
                </div>
            </div>
            </div>
            <Footer variant="app" />
        </div>
    );
};

export default PendingApproval;

